import { render, staticRenderFns } from "./AreaPhoneInput.vue?vue&type=template&id=79aa4c2e&scoped=true";
import script from "./AreaPhoneInput.vue?vue&type=script&lang=js";
export * from "./AreaPhoneInput.vue?vue&type=script&lang=js";
import style0 from "./AreaPhoneInput.vue?vue&type=style&index=0&id=79aa4c2e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "79aa4c2e", null);
export default component.exports;